/**
 * @generated SignedSource<<ce5493179dad5bb3389cd7fb6d1b7718>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderEmbedded_withAIFilters$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAIFilters">;
  readonly " $fragmentType": "JQLBuilderEmbedded_withAIFilters";
};
export type JQLBuilderEmbedded_withAIFilters$key = {
  readonly " $data"?: JQLBuilderEmbedded_withAIFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderEmbedded_withAIFilters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JQLBuilderEmbedded_withAIFilters",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderWithAIFilters"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "b676862c10a90bc2656d88d3b0b099c7";

export default node;
